// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__1aDws","loaderOuter":"PageOverlayLoader_loaderOuter__2U1AK"};